export default "__VITE_ASSET__BWwMP7LU__"